import type { FC, ReactNode } from 'react'
import { Icon } from '../../../elementsv2'

type Props = { children?: ReactNode; title: string; icon: FC<{ className?: string }> }

export const BotCardSection: FC<Props> = ({ children, icon, title }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <Icon icon={icon} color="gray" />
        <span className="text-sm text-gray-12 ">{title}</span>
      </div>
      {children}
    </div>
  )
}
